import { ExportOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';

import ExternalLink from '../components/external-link';

const FAKTUROID_BASE = 'https://app.fakturoid.cz/wawahi';

export function FakturoidSubjectLink({
  id,
}: {
  id: number;
}): React.ReactElement {
  return (
    <ExternalLink
      to={`${FAKTUROID_BASE}/subjects/${id}`}
      label={String(id)}
      ariaLabel="Open in Fakturoid"
    />
  );
}

export const getFakturoidInvoiceUrl = (id: number): string =>
  `${FAKTUROID_BASE}/invoices/${id}`;

export function FakturoidInvoiceLink({
  number,
  url,
  invoiceType,
}: {
  number: string;
  url: string;
  invoiceType: string;
}): React.ReactElement {
  return (
    <Tooltip title={invoiceType}>
      <a href={url} target="_blank" rel="noreferrer">
        {number} <ExportOutlined />
      </a>
    </Tooltip>
  );
}
